export const purpleCTA = '#7b1fa2';